import api from '@/api';
import store from '@/store';

const resource = 'ei/disciplina';

export default {
  getSelectDisciplinaProfessorPeriodo(data) {
    return api.get(`${resource}/select-disciplinas-professor-periodo`, {
      params: data,
    });
  },

  getSelectDisciplinaPerfilPeriodo(data) {
    return api.get(`${resource}/select-disciplinas-perfil-periodo`, {
      params: {...data,
        identificadorperfilatual: store.getters.userDadosPerfilAtual.identificadorperfil,
      },
    });
  },

  getSelectDisciplinaConceito(data) {
    return api.get(`${resource}/select-disciplina-conceito`, {
      params: data,
    });
  },

  getselectDisciplinaDoPeriodoAvaliativo(data) {
    return api.get(`${resource}/select-disciplina-do-periodo-avaliativo`, {
      params: data,
    });
  },
};
